import { FC } from "react";
import "./addBook.css";
import { useNavigate } from "react-router-dom";
import { Book, Props } from "../types";
import { RowLibrary } from "../components/RowLibrary";
import { LineChart } from "../components/LineChart";
import { track } from "@amplitude/analytics-browser";

export const Home: FC<Props> = ({
  setBooks,
  books,
  setLastBooksRead,
  lastBooksRead,
}) => {
  const navigate = useNavigate();

  const onSelectBook = (book: Book) => {
    track("Home: selectBook on Row library", book);
    setLastBooksRead(book.id);
    if (!books[book.id]) {
      //create new record
      setBooks((bs) => {
        return { ...bs, [book.id]: { ...book, readingSessions: [] } };
      });
    }
    navigate(`/tracker/${book.id}`);
  };

  const goToLibrary = () => {
    track("Home: go to library");
    navigate("/library");
  };
  return (
    <div>
      <h2>BeRead</h2>
      <p className="secctionTitle link" onClick={goToLibrary}>
        My library
      </p>
      <RowLibrary
        books={books}
        lastBooksRead={lastBooksRead}
        onSelectBook={onSelectBook}
      />
      <p className="secctionTitle "> stats</p>
      <LineChart books={books} />
      <p className="secctionTitle "> friends' activity</p>
      coming soon
    </div>
  );
};
